<div class="delivery-details"
     [mmTestId]="'ORDER_HISTORY.ORDER_LINE_DELIVERY_INFO'">
    <div *ngIf="isPeriodEnabled"
         [mmTestTarget]="'expected-delivery-period'"
         class="delivery-details__period">
        <strong>
            <span class="mr-gutter-xs">{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_DELIVERY_DATE' | translate }}</span>
            {{ expectedDeliveryPeriod?.start | dateRangeView : expectedDeliveryPeriod?.end }}
        </strong>
    </div>
    <div *ngIf="isShipped && trackings?.length"
         class="delivery-details__trackings">
        <div *ngFor="let originData of (trackings | productDelivery) as trackingsList"
             [mmTestTarget]="'order-line-tracking'">
            <div [mmTestTarget]="'order-line-delivery-carrier'"
                 *ngFor="let carrierData of originData.carriers">
                <div>
                    <span class="multiple-delivery__label"
                          [mmTestTarget]="'order-line-delivery-carrier-label'">
                          {{'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_SHIPPING_DETAILS.CARRIER' | translate}}:
                    </span>
                    <span *ngIf="carrierData?.carrier !== notDefinedCarrierId; else noCarrierTmpl"
                          [mmTestTarget]="'order-line-delivery-carrier-value'">
                          {{carrierData.carrier}}
                    </span>
                </div>
                <div class="delivery-details__tracking-group">
                    <div class="delivery-details__label"
                         [mmTestTarget]="'order-line-delivery-tracking-id-title'">
                        {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_SHIPPING_DETAILS.TRACKING_ID' | translate }}:
                    </div>
                    <app-tracking-number-list [trackings]="carrierData?.trackings">
                    </app-tracking-number-list>
                </div>
            </div>
        </div>
        <ng-template #noCarrierTmpl>
            <span class="delivery-details__empty-state">
                {{'PAGES.ACCOUNT.ORDERS_HISTORY.ORDER_LINE_SHIPPING_DETAILS.NOT_DEFINED' | translate}}
            </span>
        </ng-template>
    </div>
</div>
